import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b2876ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "iot-box"
};
const _hoisted_2 = {
  class: "item"
};
const _hoisted_3 = {
  class: "icon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.itemList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
      src: item.icon,
      alt: ""
    }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.value), 1)]);
  }), 256))]);
}